import React from 'react'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI.js'
import EscrowTxnListUI from '../../../components/superUser/nodalTxn/EscrowTxnListUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI.js'

const EscrowTxnListPageUI = ({ context, errorList, accountNumber, transactionList, filteredTransactionList,
  details, onDetailsClick, account,
  searchFilter, onSearchFilterChange, onRefreshClick, downloadRequested, onDownloadEsccTxnsClick,
  onCopyToClipboard, copyToClipboardText,
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_txn_l' backLink='/su/accounts'
    headerText='Escrow Account' centered={!account|| !transactionList || !errorList} page='escrow'
    account={account} dimension='w768'
  >
    {
      (!account || !transactionList || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      account && transactionList &&
      <EscrowTxnListUI context={context}
        accountNumber={accountNumber}
        transactionList={filteredTransactionList}
        onRefreshClick={onRefreshClick}
        onDownloadEsccTxnsClick={onDownloadEsccTxnsClick}
        searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
        onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
        details={details} onDetailsClick={onDetailsClick}
      />
    }
  </SuperUserAccountPageUI>

export default EscrowTxnListPageUI
